import { List } from "immutable";

import CourseUserSectionsSpec from "seneca-common/features/assignments/state/models/spec/CourseUserSectionsSpec";
import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import * as users from "./users";

export function getCourseId(state: CourseUserSectionsSpec) {
  return state.courseId;
}

export function getUsers(state: CourseUserSectionsSpec) {
  return state.users;
}

// @ts-ignore
export const getUserSectionIds: (
  state: CourseUserSectionsSpec,
  userId: string
) => List<string> = composeSelector(getUsers, users.getUserSectionIds);

export const getAllSectionIds: (state: CourseUserSectionsSpec) => List<string> =
  composeSelector(getUsers, users.getAllSectionIds);
